import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  MenuItem,
  FormControl,
} from "@mui/material";
import { Container, StyledPlanBox, StyledSelect } from "./styles";

interface Option {
  label: string;
  value: string;
}

interface SelectPlanProps {
  value: string;
  options: Option[];
  onChange: (newValue: string) => void;
}

const SelectPlan: React.FC<SelectPlanProps> = ({
  value,
  options,
  onChange,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleToggle = () => {
    setShowDropdown(true);
  };

  const handleChange = (event: any) => {
    onChange(event.target.value);
    setShowDropdown(false);
  };

  return (
    <Box>
      <Container elevation={0}>
        {!showDropdown ? (
          <StyledPlanBox>
            <Typography>{options.find((o) => o.value === value)?.label}</Typography>
            <Button variant="text" onClick={handleToggle}>
              Change Plan
            </Button>
          </StyledPlanBox>
        ) : (
          <FormControl>
            <StyledSelect 
              value={value} 
              onChange={handleChange} 
              autoFocus 
            >              
              {options.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </StyledSelect>
          </FormControl>
        )}
      </Container>
    </Box>
  );
};

export default SelectPlan;